module.exports = function() {
  return new Worker(__webpack_public_path__ + "40a23ba3c107330575e7.worker.js");
};